<template>
  <div>
    <Navbar />
    <!-- <Breadcrumb /> -->
    <div class="card col-12">
      <div class="card-header">
        <h5 class="mb-0">Import Users</h5>
      </div>
      <div class="card-body">
        <ul class="nav nav-tabs col-12 px-0 mx-auto mt-2" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="step1-tab" data-bs-toggle="tab" data-bs-target="#step1" type="button" role="tab">
              <div class="col-12 text-center">Step 1 - Select Excel file</div>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="step2-tab" data-bs-toggle="tab" data-bs-target="#step2" type="button" role="tab">
              <div class="col-12 text-center">Step 2 - Check file format</div>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="step3-tab" data-bs-toggle="tab" data-bs-target="#step3" type="button" role="tab">
              <div class="col-12 text-center">Step 3 - Import data</div>
            </button>
          </li>
        </ul>
        
        <div class="tab-content mt-3">
          <!-- Step 1 Tab -->
          <div class="tab-pane fade show active px-0 col-12 border-0" id="step1" role="tabpanel">
            <div class="card border-0 col-12">
              <div class="card-body">
                <div v-if="message" class="alert alert-danger alert-dismissible fade show" role="alert" v-html="message"></div>
                
                <div v-show="!uploading">
                  <p>This program will import users to the GDQ system. If a user's e-mail address is already found in the system, the user information will be updated with the information in the Excel file.</p>
                  <p>Your Excel file should have one heading row and one row for each user with the following columns:</p>
                  <ul>
                    <li>Column A: User name - required - this is used for login and must be unique and cannot contain spaces of special characters</li>
                    <li>Column B: Password - leave this field blank to not update the password fo existing users. If the field is blank, any new users in the Excel file will get password 'gdq2020!'</li>
                    <li>Column C: E-mail address - must be unique</li>
                    <li>Column D: Family Name - optional</li>
                    <li>Column E: First Name - optional</li>
                    <li>Column F: Telephone - optional</li>
                    <li>Column G: Country Name - if no country name is specified, the system will set country to Sweden</li>
                    <li>Column H: Affiliated Company Name - optional</li>
                    <li>Column I: VAT Number - optional</li>
                    <li>Column J: Is Administrator - put the number 1 in this column to indicate that the user is an administrator</li>
                    <li>Column K: Is ToT - put the number 1 in this column to indicate that the user is a ToT</li>
                    <li>Column L: Is Consultant - put the number 1 in this column to indicate that the user is a consultant</li>
                  </ul>
                </div>
                
                <div v-show="uploading" class="text-center">
                  <div class="spinner-grow text-primary" style="width: 4rem;height: 4rem;" role="status">
                    <span class="visually-hidden">Uploading...</span>
                  </div>
                </div>
                
                <p v-show="!uploading">
                  <a class="button" href="/GDQ_Consultants_Import_Template.xls" target="_blank" download="/GDQ_Consultants_Import_Template.xls">
                    <span class="icon-file-excel"></span>&nbsp;Click here to download the Excel template
                  </a>
                </p>
                
                <div v-show="!uploading" class="mb-3">
                  <input
                    type="file"
                    class="form-control col-8"
                    ref="import_file"
                    accept="application/vnd.ms-excel"
                    @change="handleFileChange"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <!-- Step 2 Tab -->
          <div class="tab-pane fade px-0 col-12 border-0" id="step2" role="tabpanel">
            <div class="card border-0 mx-0 px-0 col-12">
              <div class="card-body">
                <div class="row"></div>
              </div>
            </div>
          </div>
          
          <!-- Step 3 Tab -->
          <div class="tab-pane fade px-0 col-12 border-0" id="step3" role="tabpanel">
            <div class="card border-0 mx-0 px-0 col-12">
              <div class="card-body">
                <div class="row"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';

export default {
  name: 'ImportConsultants',
  components: {
    Navbar,
    // Breadcrumb
  },
  data() {
    return {
      message: '',
      uploading: false,
      import_file: null,
      import_file_valid: null,
    }
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.import_file = file;
        this.submitFile();
      }
    },
    submitFile() {
      if (this.import_file != null && this.import_file.name != '') {
        this.uploading = true;
        const fd = new FormData();
        fd.append('group_id', this.$store.state.currentgroup_id);
        fd.append('file', this.import_file);
        this.$store.dispatch('users_upload', fd)
        .then((result) => {
          if (result.data.errors.length > 0) {
            for (var i = 0; i < result.data.errors.length; i++) {
              this.message = this.message + result.data.errors[i] + '<br>';
            }
          }
        })
        .then(() => {
          this.uploading = false;
        });
      }
    },
    checkform() {
      var formok = true;
      this.import_file_valid = true;
      if (this.import_file == null && this.import_id < 1) {
        this.import_file_valid = false;
        formok = false;
      }
      return formok;
    },
    importfile_save() {
    },
  },
}
</script>
